/* eslint-disable no-underscore-dangle */
import React, { useState } from 'react'
import {
  Col, Input, Tabs, List, Avatar, Button, Skeleton,
} from 'antd'
import { compose, withApollo } from 'react-apollo'
import { useQuery } from '@apollo/react-hooks'

import registrationQuery from '../graphql/queries/registrations'

import {
  Racecomponents,
  RaceHeadercomponents,
  RaceRowcomponents,
  RaceTextcomponents,
  RaceSearchcomponents,
} from './styled-components/raceStyled'

// import AFM from '../img/AFM-25.png'
// import runer from '../img/runer-silhouette-running-fast.png'
const { Search } = Input
const { TabPane } = Tabs

function callback(key) {
  console.log(key)
}

const ProfileContainer = ({ client }) => {
  // let { sort, status } = this.state
  const [status] = useState('')
  const [loading] = useState(false)
  const [skip] = useState(0)
  const _operators = {
    status: {
      in: ['', 'all'].includes(status) ? ['paid', 'draft', 'submitted', 'payment_verifying', 'accepted', 'rejected'] : status,
    },
  }
  // const limit = 100
  const sort = '_ID_DESC'
  const start = 3
  const filter = { _operators }
  const registrations = useQuery(registrationQuery, {
    client,
    fetchPolicy: 'cache',
    variables: {
      sort, filter, limit: start, skip,
    },
  })

  console.log(!registrations.loading ? registrations : '')
  const onLoadMore = (e) => {
    e.preventDefault()
    registrations.fetchMore({
      // note this is a different query than the one used in the
      // Query component
      query: registrationQuery,
      variables: { skip: registrations.data.registrations.length, limit: registrations.variables.limit },
      updateQuery: (previousResult, { fetchMoreResult }) => {
        const newRegistrations = fetchMoreResult.registrations
        return {
          registrations: [...previousResult.registrations, ...newRegistrations],
        }
      },
    })
  }
  const loadMore = !loading ? (
    <div
      style={{
        textAlign: 'center',
        marginTop: 12,
        height: 32,
        lineHeight: '32px',
      }}
    >
      <Button onClick={onLoadMore}>See more... </Button>
    </div>
  ) : null
  return (
    <Racecomponents>
      <RaceHeadercomponents>
        <Col>
          <RaceRowcomponents>
            <Col>
              <RaceTextcomponents>
                Race
              </RaceTextcomponents>
            </Col>
            <RaceSearchcomponents>
              <Search
                placeholder="ค้นหางานวิ่ง"
                onSearch={value => console.log(value)}
                // size="large"
                style={{ width: '300px', borderRadius: '50px' }}
              />
            </RaceSearchcomponents>
          </RaceRowcomponents>
        </Col>
        {/* <Col style={{ border: '1px solid rgba(153, 153, 153, 0.26)', width: '600px' }}/>  */}
        <Col style={{ textAlign: 'left' }}>
          <Tabs defaultActiveKey="1" onChange={callback} type="card">
            <TabPane tab="งานวิ่งของฉัน" key="1">
              <List
                className="demo-loadmore-list"
                loading={registrations.loading}
                itemLayout="horizontal"
                loadMore={loadMore}
                dataSource={!registrations.loading ? registrations.data.registrations : []}
                renderItem={item => (
                  <List.Item
                    actions={[<a key="list-loadmore-edit">edit</a>, <a key="list-loadmore-more">more</a>]}
                  >
                    <Skeleton avatar title={false} loading={item.loading} active>
                      <List.Item.Meta
                        avatar={
                          <Avatar src="https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png" />
                        }
                        title={<a href={'https://race.thai.run/'.concat(item.event.slug)}>{item.event.name.en}</a>}
                        description="Placeholder description"
                      />
                      {/* <div>content</div> */}
                    </Skeleton>
                  </List.Item>
                )}
              />
            </TabPane>
            <TabPane tab="งานวิ่งที่น่าสนใจ" key="2">
              Content of Tab Pane 2
            </TabPane>
          </Tabs>
        </Col>
      </RaceHeadercomponents>
    </Racecomponents>
  )
}

export default compose(withApollo)(ProfileContainer)



// WEBPACK FOOTER //
// ./src/components/race.js